import React from 'react';
import IframeResizer from 'iframe-resizer-react';
import { ButtonToolbar, Form } from 'rsuite';
import { getCurrentUserToken } from '../services/authorization';
import ApiTokenReset from '../mpi/ApiTokenReset';

export default function ShoptetIntegrationSetup() {
  const currentUserToken = getCurrentUserToken();
  return (
    <div>
      <br />
      <h4>Shoptet Setup</h4>
      <br />
      <Form
        layout="horizontal"
      >
        <Form.Group>
          <ButtonToolbar>
            <ApiTokenReset />
          </ButtonToolbar>
        </Form.Group>
      </Form>
      <br />
      <IframeResizer
        src={`/shoptet/settings/?user_token=${currentUserToken}`}
        style={{ minWidth: '100%', border: 'none' }}
        heightCalculationMethod="lowestElement"
        inPageLinks
      />
    </div>
  );
}
